var components;
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-uni-view',{staticClass:"u-time-axis-item"},[_vm._t("content"),_c('v-uni-view',{staticClass:"u-time-axis-node",style:([_vm.nodeStyle])},[_vm._t("node",[_c('v-uni-view',{staticClass:"u-dot"})])],2)],2)}
var recyclableRender = false
var staticRenderFns = []

export { render, staticRenderFns, recyclableRender, components }